export enum NotificationType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success'
}

export type Notification = {
  type: NotificationType,
  text: string,
}
